import { useEffect, useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button, Dialog, DialogContent } from '@nw/ui';
import type { QuickAction } from '@nw/web-platform';

/** Contextual capture: only actions that enabled modules actually support. */
export function QuickCapture({ open, onOpenChange, actions, initial }: { open: boolean; onOpenChange: (o: boolean) => void; actions: QuickAction[]; initial?: string | null }) {
  const [chosen, setChosen] = useState<QuickAction | null>(null);
  useEffect(() => {
    if (!open) setChosen(null);
    else if (initial) setChosen(actions.find((a) => a.id === initial) ?? null);
  }, [open, initial, actions]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent title={chosen ? chosen.label : 'Capture something'} description={chosen ? chosen.description : 'Choose what you want to add.'}>
        {chosen ? (
          <>
            <Button variant="quiet" size="sm" className="mb-4 -ms-2" onClick={() => setChosen(null)}>
              <ArrowLeft /> Other choices
            </Button>
            <chosen.Component onDone={() => onOpenChange(false)} />
          </>
        ) : actions.length === 0 ? (
          <p className="text-[var(--nw-quiet)]">Turn on Library or Mind Networks in settings to capture books and thoughts.</p>
        ) : (
          <ul className="flex flex-col gap-2">
            {actions.map((a) => (
              <li key={a.id}>
                <button type="button" onClick={() => setChosen(a)} className="flex w-full items-start gap-4 rounded-[var(--nw-radius-panel)] border border-[var(--nw-line)] p-4 text-start transition-colors hover:border-[var(--nw-river)]">
                  <a.icon className="mt-0.5 size-5 shrink-0 text-[var(--nw-river)]" />
                  <span>
                    <span className="block font-semibold">{a.label}</span>
                    <span className="block text-sm text-[var(--nw-quiet)]">{a.description}</span>
                  </span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
}
